import * as React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

function Sidebar(props) {
  const { archives, description, title, loading, error } = props;

  return (
    <Stack spacing={3}>
      {/* Aboutセクション */}
      <Paper elevation={0} sx={{ p: 2, bgcolor: 'grey.200' }}>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>

        {/* 画像 */}
        <Box sx={{ textAlign: 'center', mt: 2, mb: 2 }}>
          <img
            src="/images/sidebar.png"
            alt="Aboutセクションの画像"
            style={{ 
              maxWidth: '75%', 
              maxHeight: '75%', 
              borderRadius: '8px' 
            }}
          />
        </Box>

        <Typography variant="body1" component="div" sx={{ whiteSpace: 'pre-wrap' }}>
          {description}
        </Typography>
      </Paper>

      {/* アーカイブセクション */}
      <Paper elevation={0} sx={{ p: 2, bgcolor: 'grey.200' }}>
        <Typography variant="h6" gutterBottom>
          アーカイブ
        </Typography>
        
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
            <CircularProgress size={24} />
          </Box>
        ) : error ? (
          <Typography variant="body2" color="error" sx={{ p: 1 }}>
            アーカイブの読み込みに失敗しました
          </Typography>
        ) : archives && archives.length > 0 ? (
          <Stack spacing={1}>
            {archives.map((archive) => (
              <Link 
                display="block" 
                variant="body1" 
                href={archive.url} 
                key={archive.title}
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                {archive.title}
              </Link>
            ))}
          </Stack>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ p: 1 }}>
            アーカイブがありません
          </Typography>
        )}
      </Paper>
    </Stack>
  );
}

Sidebar.propTypes = {
  archives: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

export default Sidebar;